import $ from 'jquery';
import PackLearnTune from "./actions/PackLearnTune.es6";

const DEFAULTS = {
    qTerm: true,
    qDefinition: false,
    mSelect: true,
    mWrite: true
};

export default class PackLearnConfig {
    constructor(opts) {
        this.config = $.extend(DEFAULTS, opts.config);
        this.l18n = opts.l18n;
        this.packId = opts.packId;
        this.authenticated = !!opts.authenticated;

        this.onSave = opts.onSave;
        this.onReset = opts.onReset;
    }

    get mWrite() {
        return this.config.mWrite;
    }

    get mSelect() {
        return this.config.mSelect;
    }

    get qTerm() {
        return this.config.qTerm;
    }

    get qDefinition() {
        return this.config.qDefinition;
    }

    get playAudio() {
        return this.config.playAudio;
    }

    show() {
        const options = {
            l18n: this.l18n,
            config: $.extend({}, this.config),
            callback: config => {
                this.config = $.extend(this.config, config);
                this.saveConfig();
                this.onSave();
            },
            clearProgress: () => {
                this.resetProgress();
                this.onReset();
            }
        };
        new PackLearnTune(options).execute();
    }

    saveConfig() {
        if (this.authenticated) {
            $.ajax({
                url: `${Flashcards.root}/set/${this.packId}/save-learn-config.ajax`,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(this.config)
            });
        }
    }

    resetProgress() {
        if (this.authenticated) {
            $.ajax({
                url: `${Flashcards.root}/set/${this.packId}/learn/reset.ajax`,
                type: 'POST',
                contentType: 'application/json'
            });
        }
    }
}